'use strict';

exports.__esModule = true;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _componentsCreateCode = require('./components/createCode');

var _componentsCreateCode2 = _interopRequireDefault(_componentsCreateCode);

var _utilsParser = require('./utils/parser');

var _utilsParser2 = _interopRequireDefault(_utilsParser);

exports['default'] = _componentsCreateCode2['default'](_react2['default'], _utilsParser2['default']);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-embed-code/lib/index.js
// module id = uOE8
// module chunks = 0